import React from 'react';
import { CheckoutSummaryPriceDetails } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryPriceDetails';
import { CheckoutSummaryFooter } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryFooter';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';
import { SummaryLayout } from 'components/views/pages/Checkout/CheckoutSummary/SummaryLayout';

interface Props {
  isLastStep: boolean;
}

export const CheckoutSummary = ({
  checkoutData,
  paymentType,
  isLastStep,
  bookingData,
  pid,
}: Pick<CheckoutStepProps, 'checkoutData' | 'paymentType' | 'bookingData' | 'pid'> & Props) => {
  return (
    <SummaryLayout pid={pid}>
      <CheckoutSummaryPriceDetails checkoutData={checkoutData} bookingData={bookingData} isLastStep={isLastStep} />
      <CheckoutSummaryFooter
        paymentType={paymentType}
        checkoutData={checkoutData}
        isLastStep={isLastStep}
        bookingData={bookingData}
      />
    </SummaryLayout>
  );
};
